import React, { useEffect, useState } from 'react'
import SearchBar from './SearchBar'
import general from '../../general'
import Dialog from '../../lib/Dialog'
import { NavLink } from '../../lib/Navigation'
import useActiveState from '../../lib/useActiveState'
import AuthAlert from '../components/AuthAlert'

export default function Session(props) {

  const [data, setData] = useState([])
  const [user, setUser] = useActiveState('user')
  const [isCheckAuth, setIsCheckAuth] = useState(false); //实名认证弹框状态

  const getHotGameCluster = () => {
    general.axios.post('/base/yunxin/getHotGameCluster', { source: 'myself' })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          setData(data.hot_game_cluster)
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  useEffect(() => {
    getHotGameCluster()
  }, [])

  const join = (item) => {
    if (user.isCheckAuth && !user.isRealNameAuth) {
      setIsCheckAuth(true)
      setTimeout(() => {
        const div = document.getElementsByClassName("pay-check-auth")[0]
        const target = document.getElementsByClassName("adm-tabs")[0]
        target.insertAdjacentElement('afterend', div);
      }, 10);
      return
    }
    general.axios.post('/base/yunxin/joinTeams', { topic_id: item.topic_id })
      .then(res => {
        const { data, status } = res.data
        if (status.succeed) {
          const { tid } = data.info
          if (localStorage.getItem('yx_login')) {
            general.history.push(`/chat?tid=${tid}`)
          } else {
            PubSub.publish('loginSubscribe', true)
            setTimeout(() => {
              general.history.push(`/chat?tid=${tid}`)
            }, 2000)
          }
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  return (
    <div className='session-index'>
      <SearchBar></SearchBar>
      <NavLink className="empty">{user.isLogin ? '您还未加入任何群聊' : '登录后查看加入的群聊 >'}</NavLink>
      <div className="header">热门群聊</div>
      <div className="chats">
        {data.map((item, index) => {
          return (
            <div className='item' key={index}>
              <div className='imgs'>
                <img className='icon' src={item.icon} alt="" />
                <img className='tip' src={'resources/250410/hot.png'} alt="" />
              </div>
              <div className="name">{item.tname}</div>
              <NavLink onClick={() => join(item)} className="join">加群</NavLink>
            </div>
          )
        })}
      </div>
      
      <AuthAlert isCheckAuth={isCheckAuth} onClose={() => setIsCheckAuth(false)} handleAuthSuccess={info => {
        setUser({ ...user, ...info })
      }}></AuthAlert>
    </div>
  )
}
